import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import { FormControl, Stack, Grid, Typography, TextField, Tab, Tabs } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';
import { checkNumber, checkString } from '../utilities/FormValidation';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import customStyles from 'app/shared-components/SelectCustomStyle';
import dayjs from 'dayjs';
import CustomDatePicker from '../utilities/CustomDatePicker';
import CustomTimePicker from '../utilities/CustomTimePicker';
import moment from 'moment';


const initialValue = {
    employeeId: "",
    employeeName: "",
    department: "",
    attendanceCategory: "",
    attendanceDuration: "",
    logDate: null,
    logTimeIn: null,
    logTimeOut: null,
}

const attendanceCategoryOptions = [
    { value: "HOME_OFFICE", label: "HOME OFFICE" },
    { value: "IN_OFFICE", label: "IN OFFICE" },
    { value: "ABROAD_ATT", label: "ABROAD ATT" },
    { value: "OVERTIME", label: "OVERTIME" },
]

const AttendanceForm = () => {
    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.attendance}`;
    const employeeURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;

    const [tabValue, setTabValue] = useState(0);
    const params = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [validError, setValidError] = useState([]);
    const [checkSubmit, setCheckSubmit] = useState(false);
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [hideDelete, setHideDelete] = useState(true);
    const [editData, setEditData] = useState();
    const [saveDisable, setSaveDisable] = useState(true);
    const [attendanceData, setAttendanceData] = useState(initialValue);
    const [employeeData, setEmployeeData] = useState();

    const getEmployees = async () => {
        try {
            const list = await OAuthService.getList(employeeURL + `?sort=name,asc&size=1000`);
            let employees = list.data?._embedded?.employees;
            employees = employees.map((employee) => {
                const empFullName = `${employee.empFirstName} ${employee.empMiddleName} ${employee.empLastName}`;
                return {
                    value: employee.employeeId,
                    label: empFullName,
                    department: employee.department
                }
            })
            setEmployeeData(employees);
        } catch (error) {
            setError(error.message);
        }
    }

    const handleSubmit = async () => {
        setCheckSubmit(true);
        try {
            if (params.id) {
                await OAuthService.updateData(url, params.id, attendanceData);
                setSuccessMsg("Data Updated Successfully");
                setSnackState(true);
                setTimeout(() => { navigate('/attendance'); }, 800);
            } else {
                await OAuthService.addData(url, attendanceData);
                setSuccessMsg("Data saved Successfully");
                setSnackState(true);
                setTimeout(() => { navigate('/attendance'); }, 800);
            }
        } catch (error) {
            setError(error.message)
            return;
        }
    }


    const getAttendanceInfo = async () => {
        try {
            if (params.id) {
                setSaveDisable(true)
                const result = await OAuthService.getEditData(url, params.id);
                const attendanceInfoe = result?.data;
                setAttendanceData(attendanceInfoe);
                setEditData(attendanceInfoe);
            }
        } catch (e) {
            console.log(e);
        }
    }


    const handleDelete = async () => {

        try {
            if (params.id) {
                setSaveDisable(true)
                await OAuthService.deleteData(url, params.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                setTimeout(() => { navigate('/attendance') }, 800);
            }

        } catch (error) {
            console.log("error", error);
            setError(error.message);
        }
    }

    useEffect(() => {
        if (params.id) {
            getAttendanceInfo();
            setHideDelete(false);
        }
        getEmployees();
    }, [params.id])



    const handleChange = (event, key) => {
        console.log('event', event)
        if (key === "logTimeIn") {
            setAttendanceData({ ...attendanceData, logTimeIn: event });
        } else if (key === "logTimeOut") {
            setAttendanceData({ ...attendanceData, logTimeOut: event });
        } else {
            setAttendanceData({ ...attendanceData, [event.target.name]: event.target.value });
        }
    }

    const handleLogDateChange = (event) => {
        setAttendanceData({ ...attendanceData, logDate: moment(event).format('YYYY-MM-DD') });
    }

    const handleAttendanceCategoryChange = (data) => {
        setAttendanceData({ ...attendanceData, attendanceCategory: data.value });
    };
    const handleEmployeeChange = (data) => {
        setAttendanceData({ ...attendanceData, employeeName: data.label, employeeId: data.value, department: data.department });
    };

    useEffect(() => {
        const errorValue = Object.values(validError).filter((item) => item !== undefined);

        if (attendanceData.employeeId && attendanceData.employeeName && attendanceData.attendanceCategory
            && attendanceData.attendanceDuration && attendanceData.logDate && attendanceData.logTimeIn && attendanceData.logTimeIn
            && errorValue.length === 0
        ) {
            if (editData) {
                if (JSON.stringify(attendanceData) !== JSON.stringify(editData)) {
                    setSaveDisable(false);
                } else {
                    setSaveDisable(true);
                }
            } else {
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    }, [attendanceData, validError]);

    const handleCancel = () => {
        navigate("/attendance")
    }

    return (
        <div className='w-full overflow-scroll'>
            <FormPageHeader
                componentName="Attendance"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                successMsg={successMsg}
                snackState={snackState}
                currentPage={params.id ? "Update Attendance" : "Add Attendance"}
                parentBreadcrumbData={[{ pageName: 'Attendance List', pageLink: '/attendance' }]}
                error={error}
                handleCancel={handleCancel}
                hideDelete={hideDelete}
                saveDisable={saveDisable}
            >

                <Tabs
          value={tabValue}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: 'w-full h-64 border-b-1' }}
        >
          <Tab 
            className="h-64" 
            label="Basic Info" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
        </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">

                <FormControl fullWidth>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Stack>
                                <label>*Employee Id</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="employeeId"
                                    value={attendanceData.employeeId}
                                    variant="outlined"
                                    style={{ backgroundColor: "dimgray" }}
                                    disabled
                                />
                            </Stack></Grid>
                        <Grid item xs={6}>
                            <Stack>
                                <label>*Department</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="department"
                                    value={attendanceData.department}
                                    variant="outlined"
                                    style={{ backgroundColor: "dimgray" }}
                                    disabled
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Stack>
                        <label>*Employee Name</label>
                        <Select
                            className="mb-16"
                            name="employeeName"
                            value={(attendanceData.employeeName && employeeData) && employeeData.filter(obj => attendanceData.employeeName === obj.label)}
                            onChange={handleEmployeeChange}
                            options={employeeData}
                            styles={customStyles()}
                        />
                    </Stack>

                    <Stack>
                        <label>*Select Attendance Category</label>
                        <Select
                            className="mb-16"
                            name="attendanceCategory"
                            value={(attendanceData.attendanceCategory && attendanceCategoryOptions) && attendanceCategoryOptions.filter(obj => attendanceData.attendanceCategory === obj.value)}
                            onChange={handleAttendanceCategoryChange}
                            options={attendanceCategoryOptions}
                            styles={customStyles()}
                        />
                        {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !department) ? "" : validError.department}</Typography> */}
                    </Stack>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Stack>
                                <label>*Attendance Duration</label>
                                <TextField
                                    className="mb-16"
                                    type="text"
                                    name="attendanceDuration"
                                    value={attendanceData.attendanceDuration}
                                    error={(checkSubmit && !attendanceData.attendanceDuration) || validError.attendanceDuration ? true : false}
                                    helperText={(checkSubmit && !attendanceData.attendanceDuration) ? "" : validError.attendanceDuration}
                                    onChange={(e) => { handleChange(e); setValidError({ ...validError, attendanceDuration: checkNumber(e.target.value) }) }}
                                    variant="outlined"
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack>
                                <label>*Log Date</label>
                                <CustomDatePicker
                                    format={'dd-MM-yyyy'}
                                    name={'logDate'}
                                    value={attendanceData.logDate}
                                    maxDate={new Date()}
                                    handleChange={handleLogDateChange}
                                />
                                {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !validUntil) ? "" : validError.validUntil}</Typography>  */}
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Stack>
                                <label>*Log Time In</label>
                                <CustomTimePicker
                                    value={attendanceData?.logTimeIn}
                                    name="logTimeIn"
                                    handleChange={(e) => handleChange(e, "logTimeIn")}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack>
                                <label>*Log Time Out</label>
                                <CustomTimePicker
                                    value={attendanceData?.logTimeOut}
                                    name="logTimeOut"
                                    handleChange={(e) => handleChange(e, "logTimeOut")}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </FormControl>

            </div>
        </div >
    )
}

export default AttendanceForm